export const letterA = {
  nouns: [
    {"evening": ["Abend", "Abende", "der", "die", "m"]},
    {"address": ["Adresse", "Adressen", "die", "die", "f"]},
    {"age": ["Alter", "Alter", "das", "die", "n"]},
    {"arrival": ["Ankunft", "Ankünfte", "die", "die", "m"]},
    {"answer": ["Antwort", "Antworten", "die", "die", "f"]},
    {"apple": ["Apfel", "Äpfel", "der", "die", "m"]},
    {"work": ["Arbeit", "Arbeiten", "die", "die", "f"]},
    {"doctor": ["Arzt", "Ärzte", "der", "die", "m"]},
    {"car": ["Auto", "Autos", "das", "die", "n"]},
    {"eye": ["Auge", "Augen", "das", "die", "n"]},
    {"departure": ["Abfahrt", "Abfahrten", "die", "die", "f"]},
    {"sender": ["Absender", "Absender", "der", "die", "m"]},
    {"offer": ["Angebot", "Angebote", "das", "die", "n"]},
    {"registration": ["Anmeldung", "Anmeldungen", "die", "die", "f"]},
    {"salutation": ["Anrede", "Anreden", "die", "die", "f"]},
    {"phone call": ["Anruf", "Anrufe", "der", "die", "m"]},
    {"answering machine": ["Anrufbeantworter", "Anrufbeantworter", "der", "die", "m"]},
    {"announcement": ["Ansage", "Ansagen", "die", "die", "f"]},
    {"connection": ["Anschluss", "Anschlüsse", "der", "die", "m"]},
    {"display": ["Anzeige", "Anzeigen", "die", "die", "f"]},
    {"apartment": ["Apartment", "Apartments", "das", "die", "n"]},
    {"appetite": ["Appetit", "Appetite", "der", "die", "m"]},
    {"workplace": ["Arbeitsplatz", "Arbeitsplätze", "der", "die", "m"]},
    {"arm": ["Arm", "Arme", "der", "die", "m"]},
    {"task": ["Aufgabe", "Aufgaben", "die", "die", "f"]},
    {"elevator": ["Aufzug", "Aufzüge", "der", "die", "m"]},
    {"excursion": ["Ausflug", "Ausflüge", "der", "die", "m"]},
    {"exit": ["Ausgang", "Ausgänge", "der", "die", "m"]},
    {"information": ["Auskunft", "Auskünfte", "die", "die", "f"]},
    {"foreign country": ["Ausland", "Ausländer", "das", "die", "n"]},
    {"foreigner": ["Ausländer", "Ausländer", "der", "die", "m"]},
    {"statement": ["Aussage", "Aussagen", "die", "die", "f"]},
    {"ID": ["Ausweis", "Ausweise", "der", "die", "m"]},
    {"highway": ["Autobahn", "Autobahnen", "die", "die", "f"]},
    {"machine": ["Automat", "Automaten", "der", "die", "m"]}
  ],
  verbs: [
    {"to answer": ["antworten", "antworte", "antwortest", "antwortet", "antwortet", "antwortet", "antworten", "antwortet", "antworten", "antworten"]},
    {"to work": ["arbeiten", "arbeite", "arbeitest", "arbeitet", "arbeitet", "arbeitet", "arbeiten", "arbeitet", "arbeiten", "arbeiten"]},
    {"to begin": ["anfangen", "fange an", "fängst an", "fängt an", "fängt an", "fängt an", "fangen an", "fangt an", "fangen an", "fangen an"]},
    {"to arrive": ["ankommen", "komme an", "kommst an", "kommt an", "kommt an", "kommt an", "kommen an", "kommt an", "kommen an", "kommen an"]},
    {"to depart": ["abfahren", "fahre ab", "fährst ab", "fährt ab", "fährt ab", "fährt ab", "fahren ab", "fahrt ab", "fahren ab", "fahren ab"]},
    {"to pick up": ["abholen", "hole ab", "holst ab", "holt ab", "holt ab", "holt ab", "holen ab", "holt ab", "holen ab", "holen ab"]},
    {"to offer": ["anbieten", "biete an", "bietest an", "bietet an", "bietet an", "bietet an", "bieten an", "bietet an", "bieten an", "bieten an"]},
    {"to click": ["anklicken", "klicke an", "klickst an", "klickt an", "klickt an", "klickt an", "klicken an", "klickt an", "klicken an", "klicken an"]},
    {"to tick": ["ankreuzen", "kreuze an", "kreuzt an", "kreuzt an", "kreuzt an", "kreuzt an", "kreuzen an", "kreuzt an", "kreuzen an", "kreuzen an"]},
    {"to turn on": ["anmachen", "mache an", "machst an", "macht an", "macht an", "macht an", "machen an", "macht an", "machen an", "machen an"]},
    {"to register": ["anmelden", "melde an", "meldest an", "meldet an", "meldet an", "meldet an", "melden an", "meldet an", "melden an", "melden an"]},
    {"to call": ["anrufen", "rufe an", "rufst an", "ruft an", "ruft an", "ruft an", "rufen an", "ruft an", "rufen an", "rufen an"]},
    {"to get dressed": ["anziehen", "ziehe an", "ziehst an", "zieht an", "zieht an", "zieht an", "ziehen an", "zieht an", "ziehen an", "ziehen an"]},
    {"to stop": ["aufhören", "höre auf", "hörst auf", "hört auf", "hört auf", "hört auf", "hören auf", "hört auf", "hören auf", "hören auf"]},
    {"to get up": ["aufstehen", "stehe auf", "stehst auf", "steht auf", "steht auf", "steht auf", "stehen auf", "steht auf", "stehen auf", "stehen auf"]},
    {"to fill out": ["ausfüllen", "fülle aus", "füllst aus", "füllt aus", "füllt aus", "füllt aus", "füllen aus", "füllt aus", "füllen aus", "füllen aus"]},
    {"to turn off": ["ausmachen", "mache aus", "machst aus", "macht aus", "macht aus", "macht aus", "machen aus", "macht aus", "machen aus", "machen aus"]},
    {"to look": ["aussehen", "sehe aus", "siehst aus", "sieht aus", "sieht aus", "sieht aus", "sehen aus", "seht aus", "sehen aus", "sehen aus"]},
    {"to get off": ["aussteigen", "steige aus", "steigst aus", "steigt aus", "steigt aus", "steigt aus", "steigen aus", "steigt aus", "steigen aus", "steigen aus"]},
    {"to get undressed": ["ausziehen", "ziehe aus", "ziehst aus", "zieht aus", "zieht aus", "zieht aus", "ziehen aus", "zieht aus", "ziehen aus", "ziehen aus"]},
    {"to have": ["haben", "habe", "hast", "hat", "hat", "hat", "haben", "habt", "haben", "haben"]},
    {"to be": ["sein", "bin", "bist", "ist", "ist", "ist", "sind", "seid", "sind", "sind"]},
    {"to go": ["gehen", "gehe", "gehst", "geht", "geht", "geht", "gehen", "geht", "gehen", "gehen"]},
    {"to see": ["sehen", "sehe", "siehst", "sieht", "sieht", "sieht", "sehen", "seht", "sehen", "sehen"]},
    {"to give": ["geben", "gebe", "gibst", "gibt", "gibt", "gibt", "geben", "gebt", "geben", "geben"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Abend ist schön.',
        english: 'The evening is beautiful.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Adresse ist alt.',
        english: 'The address is old.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Auto ist neu.',
        english: 'The car is new.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Apfel schmeckt gut.',
        english: 'The apple tastes good.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Arzt arbeitet hier.',
        english: 'The doctor works here.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Abfahrt war pünktlich.',
        english: 'The departure was on time.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Angebot war sehr gut.',
        english: 'The offer was very good.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Anruf kam gestern.',
        english: 'The phone call came yesterday.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Ausflug war toll.',
        english: 'The excursion was great.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Automat arbeitete nicht.',
        english: 'The machine did not work.',
        answer: 'Der',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Abend.',
        english: 'I see the evening.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Antwort.',
        english: 'He needs the answer.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Sie kauft ___ Auto.',
        english: 'She buys the car.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir haben ___ Alter.',
        english: 'We have the age.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Du besuchst ___ Arzt.',
        english: 'You visit the doctor.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er holte ___ Apfel.',
        english: 'He picked up the apple.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie füllte ___ Anmeldung aus.',
        english: 'She filled out the registration.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir machten ___ Automat aus.',
        english: 'We turned off the machine.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich sah ___ Ausgang.',
        english: 'I saw the exit.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du brauchtest ___ Auskunft.',
        english: 'You needed the information.',
        answer: 'die',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Arzt.',
        english: 'I help the doctor.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie dankt ___ Abend.',
        english: 'She thanks for the evening.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er gibt ___ Kind ___ Apfel.',
        english: 'He gives the child the apple.',
        answer: 'dem den',
        case: 'dative'
      },
      {
        german: 'Wir sprechen mit ___ Adresse.',
        english: 'We speak with the address.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Arbeit.',
        english: 'You go to the work.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er antwortete ___ Anruf.',
        english: 'He answered the phone call.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie half ___ Ausländer.',
        english: 'She helped the foreigner.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir dankten ___ Angebot.',
        english: 'We thanked for the offer.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich gab ___ Automat ___ Geld.',
        english: 'I gave the machine the money.',
        answer: 'dem das',
        case: 'dative'
      },
      {
        german: 'Du sprachst mit ___ Anschluss.',
        english: 'You spoke with the connection.',
        answer: 'dem',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The evening is beautiful.',
        german: 'Der Abend ist schön.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The doctor works here.',
        german: ['Der Arzt arbeitet hier.', 'Der Doktor arbeitet hier.'],
        type: 'translation',
        caseType: 'nominative'
      },
      {
        german: 'Du besuchst ___ Arzt.',
        english: 'You visit the doctor.',
        answer: 'den',
        case: 'accusative'
      },
      {
        english: 'I give the child the apple.',
        german: 'Ich gebe dem Kind den Apfel.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'They work in the evening.',
        german: 'Sie arbeiten am Abend.',
        type: 'translation',
        caseType: 'temporal'
      },
      {
        english: 'The departure is long.',
        german: 'Die Abfahrt ist lang.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'He hears the announcement.',
        german: 'Er hört die Ansage.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She writes the registration.',
        german: 'Sie schreibt die Anmeldung.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'We have the work.',
        german: 'Wir haben die Arbeit.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I see the exit.',
        german: 'Ich sehe den Ausgang.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The offer is good.',
        german: 'Das Angebot ist gut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'You buy the apple.',
        german: 'Du kaufst den Apfel.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He finds the exit.',
        german: 'Er findet den Ausgang.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'They use the machine.',
        german: 'Sie benutzen den Automat.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I give the address.',
        german: 'Ich gebe die Adresse.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She likes the work.',
        german: 'Sie mag die Arbeit.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'We make an excursion.',
        german: 'Wir machen einen Ausflug.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The doctor gives the answer.',
        german: ['Der Arzt gibt die Antwort.', 'Der Doktor gibt die Antwort.'],
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I call the sender.',
        german: 'Ich rufe den Absender an.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The eye is blue.',
        german: 'Das Auge ist blau.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'He buys the machine.',
        german: 'Er kauft den Automat.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She sees the arm.',
        german: 'Sie sieht den Arm.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'We need the ID.',
        german: 'Wir brauchen den Ausweis.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The excursion is beautiful.',
        german: 'Der Ausflug ist schön.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I search for the task.',
        german: 'Ich suche die Aufgabe.',
        type: 'translation',
        caseType: 'accusative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to answer" for "I"?',
        answer: 'antworte',
        verb: 'antworten',
        verbEnglish: 'to answer',
        subject: 'ich',
        conjugation: 'antworte'
      },
      {
        question: 'How do you conjugate "to work" for "you" (formal)?',
        answer: 'arbeiten',
        verb: 'arbeiten',
        verbEnglish: 'to work',
        subject: 'Sie',
        conjugation: 'arbeiten'
      },
      {
        question: 'How do you conjugate "to begin" for "he"?',
        answer: 'fängt an',
        verb: 'anfangen',
        verbEnglish: 'to begin',
        subject: 'er',
        conjugation: 'fängt an'
      },
      {
        question: 'How do you conjugate "to arrive" for "we"?',
        answer: 'kommen an',
        verb: 'ankommen',
        verbEnglish: 'to arrive',
        subject: 'wir',
        conjugation: 'kommen an'
      },
      {
        question: 'How do you conjugate "to work" for "she"?',
        answer: 'arbeitet',
        verb: 'arbeiten',
        verbEnglish: 'to work',
        subject: 'sie',
        conjugation: 'arbeitet'
      },
      {
        question: 'What is the simple past of "to answer" for "I"?',
        answer: 'antwortete',
        verb: 'antworten',
        verbEnglish: 'to answer',
        subject: 'ich',
        conjugation: 'antwortete'
      },
      {
        question: 'What is the simple past of "to work" for "he"?',
        answer: 'arbeitete',
        verb: 'arbeiten',
        verbEnglish: 'to work',
        subject: 'er',
        conjugation: 'arbeitete'
      },
      {
        question: 'What is the simple past of "to begin" for "we"?',
        answer: 'fingen an',
        verb: 'anfangen',
        verbEnglish: 'to begin',
        subject: 'wir',
        conjugation: 'fingen an'
      },
      {
        question: 'What is the simple past of "to arrive" for "she"?',
        answer: 'kam an',
        verb: 'ankommen',
        verbEnglish: 'to arrive',
        subject: 'sie',
        conjugation: 'kam an'
      },
      {
        question: 'What is the simple past of "to have" for "I"?',
        answer: 'hatte',
        verb: 'haben',
        verbEnglish: 'to have',
        subject: 'ich',
        conjugation: 'hatte'
      },
      {
        question: 'What is the simple past of "to be" for "he"?',
        answer: 'war',
        verb: 'sein',
        verbEnglish: 'to be',
        subject: 'er',
        conjugation: 'war'
      },
      {
        question: 'What is the simple past of "to go" for "they"?',
        answer: 'gingen',
        verb: 'gehen',
        verbEnglish: 'to go',
        subject: 'sie',
        conjugation: 'gingen'
      },
      {
        question: 'What is the simple past of "to see" for "I"?',
        answer: 'sah',
        verb: 'sehen',
        verbEnglish: 'to see',
        subject: 'ich',
        conjugation: 'sah'
      },
      {
        question: 'What is the simple past of "to give" for "you" (informal)?',
        answer: 'gabst',
        verb: 'geben',
        verbEnglish: 'to give',
        subject: 'du',
        conjugation: 'gabst'
      },
      {
        question: 'What is the simple past of "to pick up" for "we"?',
        answer: 'holten ab',
        verb: 'abholen',
        verbEnglish: 'to pick up',
        subject: 'wir',
        conjugation: 'holten ab'
      },
      {
        question: 'What is the simple past of "to fill out" for "she"?',
        answer: 'füllte aus',
        verb: 'ausfüllen',
        verbEnglish: 'to fill out',
        subject: 'sie',
        conjugation: 'füllte aus'
      },
      {
        question: 'What is the simple past of "to call" for "I"?',
        answer: 'rief an',
        verb: 'anrufen',
        verbEnglish: 'to call',
        subject: 'ich',
        conjugation: 'rief an'
      },
      {
        question: 'What is the simple past of "to get up" for "he"?',
        answer: 'stand auf',
        verb: 'aufstehen',
        verbEnglish: 'to get up',
        subject: 'er',
        conjugation: 'stand auf'
      },
      {
        question: 'What is the simple past of "to turn off" for "they"?',
        answer: 'machten aus',
        verb: 'ausmachen',
        verbEnglish: 'to turn off',
        subject: 'sie',
        conjugation: 'machten aus'
      },
      {
        question: 'What is the simple past of "to stop" for "you" (formal)?',
        answer: 'hörten auf',
        verb: 'aufhören',
        verbEnglish: 'to stop',
        subject: 'Sie',
        conjugation: 'hörten auf'
      },
      {
        question: 'What is the simple past of "to depart" for "we"?',
        answer: 'fuhren ab',
        verb: 'abfahren',
        verbEnglish: 'to depart',
        subject: 'wir',
        conjugation: 'fuhren ab'
      },
      {
        question: 'What is the simple past of "to offer" for "she"?',
        answer: 'bot an',
        verb: 'anbieten',
        verbEnglish: 'to offer',
        subject: 'sie',
        conjugation: 'bot an'
      },
      {
        question: 'What is the simple past of "to register" for "I"?',
        answer: 'meldete an',
        verb: 'anmelden',
        verbEnglish: 'to register',
        subject: 'ich',
        conjugation: 'meldete an'
      },
      {
        question: 'What is the simple past of "to get dressed" for "he"?',
        answer: 'zog an',
        verb: 'anziehen',
        verbEnglish: 'to get dressed',
        subject: 'er',
        conjugation: 'zog an'
      },
      {
        question: 'What is the simple past of "to get undressed" for "they"?',
        answer: 'zogen aus',
        verb: 'ausziehen',
        verbEnglish: 'to get undressed',
        subject: 'sie',
        conjugation: 'zogen aus'
      }
    ]
  }
}
